import qs from 'qs'

import WebviewService from '@/service/webview.service'

const navigationUtils = {
  getPathname(pathname: string) {
    const splitted = pathname.split('?')
    return splitted[0]
  },
  reload() {
    if (WebviewService.isAppAndroid && WebviewService.device && WebviewService.version) {
      const url = new URL(window.location.href)
      url.searchParams.set('device', WebviewService.device)
      url.searchParams.set('version', WebviewService.version.toString())

      window.history.replaceState(null, '', url.toString())
    }

    return window.location.reload()
  },
  // 도착지로 문서 전체 로드(full 네비게이션) — 강제 업데이트가 최신 번들을 받으며 이동한다.
  navigate(destinationUrl: string) {
    const url = new URL(destinationUrl, window.location.origin)
    if (WebviewService.isAppAndroid && WebviewService.device && WebviewService.version) {
      url.searchParams.set('device', WebviewService.device)
      url.searchParams.set('version', WebviewService.version.toString())
    }
    return window.location.assign(url.toString())
  },
  addQueryParamsToPathname(pathname: string, newSearch: string) {
    const oldSearch = this.getSearch(pathname)
    const newQueryParams = this.upsertQueryParams(oldSearch, newSearch)
    return `${this.getPathname(pathname)}?${newQueryParams}`
  },
  upsertQueryParams(oldSearch: string, newSearch: string, opt = { addQueryPrefix: true }) {
    if (newSearch === '') return oldSearch
    if (oldSearch === '') return newSearch

    const newQueryParams = qs.parse(newSearch, { ignoreQueryPrefix: true })
    const oldQueryParams = qs.parse(oldSearch, { ignoreQueryPrefix: true })
    return qs.stringify(
      { ...oldQueryParams, ...newQueryParams },
      { addQueryPrefix: opt.addQueryPrefix },
    )
  },
  getSearch(pathname: string) {
    const splitted = pathname.split('?')
    if (splitted.length > 1) {
      return splitted[1]
    }
    return ''
  },
  isAbsoluteUrl(url: string): boolean {
    try {
      new URL(url)
      return true
    } catch (error) {
      return false
    }
  },
}

export default navigationUtils
